import { Box, Typography } from "@mui/material";
import React from "react";

const QuickActionWidget = (props) => {
  const { style, icon, label,textStyle, ...rest } = props;
  // Support new output structure: Image/Thumbnail, Text, Icon as nested props
  const image = props["Image/Thumbnail"];
  const text = props["Text"];
  const iconProp = props["Icon"];

  return (
    <Box
      sx={{
        border: "1px solid #83727C",
        ...style,
      }}
    >
 
      {image && image.imageUrl && (
        <Box
          component="img"
          src={image.imageUrl}
          alt={image.name || "image"}
          sx={{ ...image.style, mr: 1 }}
        />
      )}
     
      {iconProp && iconProp.icon && (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginRight: "8px",
          }}
          dangerouslySetInnerHTML={{ __html: iconProp.icon }}
        />
      )}
 
      {text && (
        <Typography sx={{ ...textStyle }}>
          {text.label || text.name}
        </Typography>
      )}
      
      {!text && (
        <Typography sx={{ ...textStyle }}>{label || "Label"}</Typography>
      )}
    </Box>
  );
};

export default QuickActionWidget;
